import { Route as ReactRouterRoute } from 'react-router-dom';
/**
 * react-router-dom Route ラップコンポーネント
 * @description https://reactrouter.com/en/main/route/route
 */
export const CustomRoute = ReactRouterRoute;
